import { render, staticRenderFns } from "./wiki.vue?vue&type=template&id=02b322e0&"
import script from "./wiki.vue?vue&type=script&lang=js&"
export * from "./wiki.vue?vue&type=script&lang=js&"
import style0 from "./wiki.vue?vue&type=style&index=0&id=02b322e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports